import React from 'react'
import './sectionSix.css'
import GooglePlayLogo from '../../../images/GooglePlayLogo'

const SectionSix = () => {
    return (
        <div className='six-container'>
            <div className='six-wrapper'>
                <h1>Download For Android</h1>
                <GooglePlayLogo scale={1.5} classname={'six-logo'}/>
            </div>
        </div>
    )
}


export default SectionSix
